
import CanvasJSReact_ReportCOD from '../chart/Chart_ReportCOD';

import {
    createdata_row
} from "./library"

import './bee-print-cod.css';

function SiteReportCOD({ reportdata, reportchart }) {
    return (
        <div className='report-wrapper'>
            <div className="page-horizontal rp-cod">
                <div className="document-header">
                    <div className="document-logo-left">
                        <img src="/images/ReportLogoleft.bmp" className="logo" style={{ opacity: "1" }} alt='logo-left1' />
                    </div>
                    <div className="document-logo-right">
                        {/* <img src="/images/ReportLogoright.bmp" className="logo" style={{ opacity: "1" }} alt='logo-right1' /> */}
                        <div className="company-box">
                            SHINING SPV 1 CO., LTD.
                        </div>
                    </div>

                    <label className="document-type">Yearly Report</label>
                    <label className="document-date">Accumulate COD to Date</label>
                    <label className="document-sitelocation" id="data-cod-header-sitename1">{reportdata.Header?.SiteName}</label>
                    <label className="document-pages">Pages 1/2</label>

                    <div className="document-capacity">
                        <div className="container">
                            <label>Capacity</label>
                            <span className='font-sarabun' id="data-cod-header-capacity1">{reportdata.Header?.Capacity}</span>
                            <span className="totalunit">kWp</span>
                        </div>
                    </div>

                    <div className="document-area">
                        <div className="container">
                            <label>Area</label>
                            <span className='font-sarabun' id="data-cod-header-area1">{reportdata.Header?.Area}</span>
                            <span className="totalunit">m<sup>2</sup></span>
                        </div>
                    </div>
                </div>

                {/* <div className="document-info">
                        <div className="document-info1">
                            <div className="container">
                                <label>ค่าแสงตามสัญญา </label>
                                <span id="data-cod-irrcontract">{reportdata.Info.IRRContract}</span>
                                <span className="totalunit">kWh/m<sup>2</sup> /yr.</span>
                            </div>
                        </div>
                    </div> */}

                <div className="itemtable">
                    <table className="tablex table-hover table-cod" id="table-cod-report1">
                        <thead className="table-header">
                            <tr className="r1">
                                <th className="horizinton-align-center bottom-black-line" id="cDateY">ปีที่</th>
                                <th className="horizinton-align-center bottom-black-line">ปี<p></p>
                                </th>
                                <th className="horizinton-align-center bottom-black-line">PR <p>Guarantee</p>
                                    <p>(%)</p>
                                </th>
                                <th className="horizinton-align-center bottom-black-line">E100(n) <p>(MWh)</p>
                                </th>
                                <th className="horizinton-align-center bottom-black-line">Acc. <p>E100(n)</p>
                                    <p>(MWh)</p>
                                </th>
                                <th className="horizinton-align-center bottom-black-line">Solar Energy(n) <p>(MWh)</p>
                                </th>
                                <th className="horizinton-align-center bottom-black-line">Compensation <p>Energy From PR(n)</p>
                                    <p>(MWh)</p>
                                </th>
                                <th className="horizinton-align-center bottom-black-line">Compensation <p>Energy From OR(n)</p>
                                    <p>(MWh)</p>
                                </th>
                                <th className="horizinton-align-center bottom-black-line">Acc. <p>Solar Energy(n)</p>
                                    <p>(MWh)</p>
                                </th>
                                <th className="horizinton-align-center bottom-black-line">Acc.E - Acc.E100
                                    <p>(MWh)</p>
                                </th>
                                <th className="horizinton-align-center bottom-black-line">ENS <p>(MWh)</p>
                                </th>
                                <th className="horizinton-align-center bottom-black-line">PR <p>(%)</p>
                                </th>
                                <th className="horizinton-align-center bottom-black-line">OR <p>(%)</p>
                                </th>
                                <th className="horizinton-align-center bottom-black-line">Est. Saving <p>(Baht)</p>
                                </th>
                                <th className="horizinton-align-center bottom-black-line">ประมาณอายุสัญญา <p>คงเหลือ</p>
                                    <p>(ปี,เดือน)</p>
                                </th>
                                <th className="horizinton-align-center bottom-black-line">ประมาณมูลค่า <p>ซื้อระบบผลิตไฟฟ้า</p>
                                    <p>(บาท)</p>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                reportdata.TableData?.map((data, index) => (
                                    index < 20 ?
                                        <tr key={"data-cod-Y" + index} className="">
                                            <td align="center" className="item col-rx-black">{data.YearNo}</td>
                                            {createdata_row("", data.Datex, true)}
                                            {createdata_row("", data.PRG, true)}
                                            {createdata_row("", data.E100, true)}
                                            {createdata_row("", data.ACCE100, true)}
                                            {createdata_row("", data.SolarEnergy, true)}
                                            {createdata_row("", data.CompEnergyPR, true)}
                                            {createdata_row("", data.CompEnergyOR, true)}
                                            {createdata_row("", data.ACCSolarEnergy, true)}
                                            {createdata_row("", data.ACCE_ACCE100, true)}
                                            {createdata_row("", data.ENS, true)}
                                            {createdata_row(data.FlagPR, data.PR_ENS, true)}
                                            {createdata_row(data.FlagOR, data.ORX_ENS, true)}
                                            {createdata_row("", data.EST_Saving, true)}
                                            {createdata_row("", data.ApprxContact, true)}
                                            {createdata_row("", data.ApprxPurchase, true)}
                                        </tr>
                                        :
                                        null
                                ))
                            }
                            <tr className="summary">
                                <td align="center" className="item col-rx-black">Total</td>
                                <td align="right" className="item col-rx-black total-disable"></td>
                                <td align="right" className="item col-rx-black total-disable"></td>
                                <td align="right" className="item col-rx-black total-disable"></td>
                                <td align="right" className="item col-rx-black total-disable"></td>
                                <td align="right" className="item col-rx-black">{reportdata.Summary?.SolarEnergy}</td>
                                <td align="right" className="item col-rx-black">{reportdata.Summary?.CompEnergyPR}</td>
                                <td align="right" className="item col-rx-black">{reportdata.Summary?.CompEnergyOR}</td>
                                <td align="right" className="item col-rx-black total-disable"></td>
                                <td align="right" className="item col-rx-black">{reportdata.Summary?.ACCE_ACCE100}</td>
                                <td align="right" className="item col-rx-black">{reportdata.Summary?.ENS}</td>
                                <td align="right" className="item col-rx-black total-disable"></td>
                                <td align="right" className="item col-rx-black total-disable"></td>
                                <td align="right" className="item col-rx-black">{reportdata.Summary?.EST_Saving}</td>
                                <td align="right" className="item col-rx-black total-disable"></td>
                                <td align="right" className="item col-rx-black total-disable"></td>
                            </tr>
                        </tbody>
                    </table>
                </div>


                <div className="doc-remark">
                    <label className="generate-remark1" id="generate-daily-print1">Printed Date : {reportdata.Header?.PrintDate}</label>
                    <label className="generate-remark2">* This reports have been generated by CPF solar monitoring system local web
                        application. *</label>
                </div>
            </div>

            <div className="page-horizontal rp-cod mt-2">
                <div className="document-header">
                    <div className="document-logo-left">
                        <img src="/images/ReportLogoleft.bmp" className="logo" style={{ opacity: "1" }} alt='logo-left2' />
                    </div>
                    <div className="document-logo-right">
                        {/* <img src="/images/ReportLogoright.bmp" className="logo" style={{ opacity: "1" }} alt='logo-right2' /> */}
                        <div className="company-box">
                            SHINING SPV 1 CO., LTD.
                        </div>
                    </div>

                    <label className="document-type">Yearly Report</label>
                    <label className="document-date">Accumulate COD to Date</label>
                    <label className="document-sitelocation" id="data-cod-header-sitename2">{reportdata.Header?.SiteName}</label>
                    <label className="document-pages">Pages 2/2</label>

                    <div className="document-capacity">
                        <div className="container">
                            <label>Capacity</label>
                            <span className='font-sarabun' id="data-cod-header-capacity2">{reportdata.Header?.Capacity}</span>
                            <span className="totalunit">kWp</span>
                        </div>
                    </div>

                    <div className="document-area">
                        <div className="container">
                            <label>Area</label>
                            <span className='font-sarabun' id="data-cod-header-area2">{reportdata.Header?.Area}</span>
                            <span className="totalunit">m<sup>2</sup></span>
                        </div>
                    </div>
                </div>

                <div className="chart-cod-wrapper">
                    <div className="chx" id="trend-cod" style={{ height: "615px", width: "100%" }}>
                        <CanvasJSReact_ReportCOD
                            info={reportdata.Header}
                            xlabel={reportchart.XLabel}
                            solorpower={reportchart.EnergyAC}
                            e100={reportchart.E100}
                            ens={reportchart.ENS}
                        ></CanvasJSReact_ReportCOD>
                    </div>
                </div>
                <div className="doc-remark">
                    <label className="generate-remark1" id="generate-daily-print1">Printed Date : {reportdata.Header?.PrintDate}</label>
                    <label className="generate-remark2">* This reports have been generated by CPF solar monitoring system local web
                        application. *</label>
                </div>
            </div>
        </div>
    )
}
export default SiteReportCOD